import { Component, OnInit } from '@angular/core';
import { PortalDataIndicatorService } from '../../services/portal-data-indicator.service';
import { PortalDataIndicatorModel } from '../../models/portal-data-indicator.model';
import { PortalDataElementListIndicatorElementComponent } from '../portal-data-element-list-indicator-element/portal-data-element-list-indicator-element.component';
import { CommonModule } from '@angular/common';
import { PortalDataElementListIndicatorElementContainerComponent } from '../portal-data-element-list-indicator-element-container/portal-data-element-list-indicator-element-container.component';

@Component({
  selector: 'app-portal-data-element-list-indicator',
  standalone: true,
  imports: [
    PortalDataElementListIndicatorElementComponent,
    CommonModule,
    PortalDataElementListIndicatorElementContainerComponent,
  ],
  templateUrl: './portal-data-element-list-indicator.component.html',
  styleUrl: './portal-data-element-list-indicator.component.scss',
})
export class PortalDataElementListIndicatorComponent implements OnInit {
  portalDataIndicatorData: PortalDataIndicatorModel = {};

  constructor(private portalDataIndicatorService: PortalDataIndicatorService) {}

  ngOnInit() {
    this.portalDataIndicatorService.data$.subscribe(response => {
      this.portalDataIndicatorData = response;
    });

    this.portalDataIndicatorService.getList().subscribe(response => {
      this.portalDataIndicatorData = response;
    });
  }
}
